import subsection from './subsection';
export default subsection;



// WEBPACK FOOTER //
// ./src/components/subsection/index.js